import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  HStack,
  useMediaQuery,
  useDisclosure,
  InputGroup,
  InputLeftElement,
  Input,
  Image,
  Text,
  Heading,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import SideDrawer from "./SideDrawer";
import LogoutModal from "../../modals/LogoutModal";
import { BsSearch } from "react-icons/bs";
import { Notification } from "../../data/Notification/Notification";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { useGetUser } from "../../../services/query/account";
import { BiLogOut } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: user } = useGetUser();
  const [showDrawerMenu, setShowDrawerMenu] = useState(false);
  const [isMobile] = useMediaQuery("(max-width: 991px)");
  const toggleSidebar = () => {
    setShowDrawerMenu(true);
  };
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20);
    });
  }, []);
  console.log(scroll);
  return (
    <Box
      h={isMobile ? "8vh" : "9vh"}
      bg={scroll ? "rgba(255, 255, 255, 0.15)" : "#fff"}
      backdropFilter={"blur(10px)"}
      pos="fixed"
      w="100%"
      zIndex="5"
      mt={isMobile ? -3 : 0}
      pl={!isMobile ? "285px" : "5px"}
      className={scroll && "header"}
    >
      <SideDrawer
        isOpen={showDrawerMenu}
        onClose={() => setShowDrawerMenu(false)}
      />
      {!isMobile ? (
        <Flex w="100%" py="4" align="center" justifyContent="space-between">
          <InputGroup w="950px">
            <InputLeftElement>
              <BsSearch size=".9rem" />
            </InputLeftElement>
            <Input
              variant="secondary"
              borderRadius="20px"
              placeholder="Search for accounts, payments, notifications, etc."
            />
          </InputGroup>
          <Flex mr="40px" gap=".5rem" align="center">
            <Notification />
            {user?.user?.Bvn?.image ? (
              <Box rounded="full" border="1px solid #E0E0E0" p="3.24px">
                <Image
                  src={`data:image/jpeg;base64,${user?.user?.Bvn?.image}`}
                  rounded="full"
                  width="39px"
                  height="39px"
                  maxH="39px"
                  maxW="39px"
                />
              </Box>
            ) : (
              <Icon
                as={FaUser}
                rounded="full"
                width="30px"
                height="30px"
                maxH="30px"
                maxW="30px"
              />
            )}
            <Box>
              <Heading fontSize="13px">
                {user?.user?.Bvn?.firstName || "welcome"}{" "}
                {user?.user?.Bvn?.lastName || ""}
              </Heading>
              <Text fontSize="11px">{user?.user?.email || "-"}</Text>
            </Box>
            <Menu>
              <MenuButton>
                <IoIosArrowDown cursor="pointer" size="1.1rem" />
              </MenuButton>
              <MenuList>
                <Link to="/more">
                  <MenuItem>Settings</MenuItem>
                </Link>
                <MenuItem onClick={onOpen}>Logout</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>
      ) : (
        <Flex justifyContent="space-between" my="3">
          <HiOutlineMenuAlt2
            size={32}
            cursor="pointer"
            onClick={toggleSidebar}
          />
          <HStack justify="center" gap=".5rem" mr={5}>
            <BiLogOut onClick={onOpen} cursor="pointer" size="1.6rem" />
          </HStack>
        </Flex>
      )}
      <LogoutModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default Header;
